import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wallet } from "lucide-react";
import { fetchWallet, PLAN_NAMES } from "../lib/billing";
import { useAuth } from "../lib/auth";
import { useT } from "../lib/i18n";

export default function WalletBadge() {
  const { t } = useT();
  const [data, setData] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    let mounted = true;
    if (!user) { setData(null); return; }
    const load = (attempt = 0) => fetchWallet()
      .then((d) => { if (mounted) setData(d); })
      .catch(() => {
        // Race on first mount after signup: cookie may not be live yet. Retry once.
        if (mounted && attempt < 1) setTimeout(() => load(attempt + 1), 600);
      });
    load();
    const onWalletUpdated = () => load();
    window.addEventListener("konzenzo:wallet-updated", onWalletUpdated);
    return () => {
      mounted = false;
      window.removeEventListener("konzenzo:wallet-updated", onWalletUpdated);
    };
  }, [user]);

  if (!data) return null;
  const balance = data.wallet?.total_balance ?? 0;
  const plan = data.plan?.plan_id || "free";
  const low = balance < 25;

  return (
    <Link
      to="/billing"
      data-testid="wallet-badge"
      className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg border text-sm font-bold font-display transition-colors ${
        low ? "border-[#F59E0B] bg-[#F59E0B]/10 text-[#0B1B3D] hover:bg-[#F59E0B]/20" : "border-slate-200 bg-white text-[#0B1B3D] hover:border-[#0EA5E9]"
      }`}
    >
      <Wallet className={`w-4 h-4 ${low ? "text-[#F59E0B]" : "text-[#0EA5E9]"}`} />
      <span>{balance}</span>
      <span className="text-[#94A3B8] font-mono-kz text-xs uppercase tracking-widest">{t("credits")} · {PLAN_NAMES[plan]}</span>
    </Link>
  );
}
